import { FilterCacheResolver } from '@sbd-doug-frontend/shared/lib/ui/filter/filter.resolver';
import { NgModule } from '@angular/core';
import {
  ExtraOptions,
  Routes,
  RouterModule,
} from '@angular/router';
import { LayoutComponent } from './layout/layout.component';
import { LayoutModule } from './layout/layout.module';
import { InitialDataResolver } from './app.resolvers';
import { AuthGuard } from './core/auth/guards/auth.guard';
import { NoAuthGuard } from './core/auth/guards/noAuth.guard';
const routerConfig: ExtraOptions = {
  // !!! Don't enable this !!!!
  // preloadingStrategy: PreloadAllModules,
  scrollPositionRestoration: 'enabled',
};

const routes: Routes = [
  // Landing routes
  {
    path: '',
    // canMatch: [NoAuthGuard],
    component: LayoutComponent,
    data: {
      layout: 'empty',
    },
    children: [
      {
        path: '',
        loadChildren: () =>
          import('./modules/landing/home/home.module').then(
            (m) => m.LandingHomeModule
          ),
      },
    ],
  },
  {
    path: '',
    canMatch: [AuthGuard],
    component: LayoutComponent,
    resolve: {
      initialData: InitialDataResolver,
    },
    children: [
      // A
      {
        path: 'accounts',
        loadChildren: () =>
          import('./modules/accounts/accounts.module').then((m) => m.AccountsModule)
      },
      {
        path: 'admin',
        loadChildren: () =>
          import('./modules/admin/admin.module').then((m) => m.AdminModule),
      },
      // B
      {
        path: 'bonds',
        loadChildren: () =>
          import('./modules/bonds/bonds.module').then((m) => m.BondsModule),
      },
      // C

      // D
      // E
      {
        path: 'events',
        loadChildren: () =>
          import('./modules/events/events.module').then((m) => m.EventsModule),
      },
      // F
      // G
      // H
      // I
      // J
      // K
      // L
      {
        path: 'leads',
        resolve: { filterCache: FilterCacheResolver },
        loadComponent: () => import('./modules/leads/leads-list.component').then(m => m.LeadsListComponent),
      },
      {
        path: 'legal',
        loadChildren: () =>
          import('@sbd-doug-frontend/app/modules/legal/terms/legal-terms.module').then(
            (m) => m.LegalTermsModule
          ),
      },
      {
        path: 'my-tasks',
        loadChildren: () =>
          import('@sbd-doug-frontend/app/modules/my-tasks/my-tasks.module').then(
            (m) => m.MyTasksModule
          ),
      },
      // N
      // O
      {
        path: 'operations',
        loadChildren: () =>
          import('./modules/operations/operations.module').then(
            (m) => m.OperationsModule
          ),
      },
      {
        path: 'payments',
        loadChildren: () =>
          import('./modules/payments/payments.module').then(
            (m) => m.PaymentsModule
          ),
      },
      // Q
      // R
      // S
      // T
      // U
      // V
      // W
      {
        path: 'website',
        loadChildren: () =>
          import('./modules/website/website.module').then(
            (m) => m.WebsiteModule
          ),
      },
      {
        path: 'quotes',
        loadChildren: () =>
          import('./modules/quotes/quotes.module').then((m) => m.QuotesModule),
      },
      {
        path: 'policy',
        loadChildren: () =>
          import('./modules/policy/policy.module').then((m) => m.PolicyModule),
      },
      {
        path: 'operations',
        loadChildren: () =>
          import('./modules/operations/operations.module').then((m) => m.OperationsModule),
      },
     /* {
        path: 'tasks',
        loadChildren: () =>
          import('./modules/tasks/tasks.module').then((m) => m.TasksModule),
      },*/
      {
        path: 'tasks',
        loadChildren: () =>
          import('./modules/tasksets/tasksets.module').then((m) => m.TasksetsModule),
      },
      {
        path: 'users',
        loadChildren: () =>
          import('./modules/users/users.module').then((m) => m.UsersModule),
      },
      {
        path: 'landingpages',
        loadChildren: () =>
          import('./modules/landing-pages/landing-pages.module').then((m) => m.LandingPagesModule),
      },
    ],
  },
  {
    path: '404-not-found',
    pathMatch: 'full',
    loadChildren: () =>
      import('./modules/error/error-404/error-404.module').then(
        (m) => m.Error404Module
      ),
  },
  // { path: '**', redirectTo: '404-not-found' },
  {
    path: '**', loadChildren: () =>
      import('./modules/error/error-404/error-404.module').then(
        (m) => m.Error404Module
      ),
  },
];

// configures NgModule imports and exports
@NgModule({
  imports: [LayoutModule, RouterModule.forRoot(routes, routerConfig)],
  exports: [RouterModule],
})
export class AppRoutingModule { }
